import React, { useEffect } from 'react';
import './index.css';

const ToggleSwitchComponent = ({ setToggle, isDisabled }) => {
  useEffect(() => {
    const handleToggleClick = (event) => {
      let switchEl = event.target;
      // If not disabled, toggle attribute
      if (!switchEl.hasAttribute('aria-readonly')) {
        let currState = switchEl.getAttribute('aria-checked');
        let newState = currState === 'true' ? false : true;
        switchEl.setAttribute('aria-checked', newState);
      }
    };

    const switchEls = document.querySelectorAll(".toggle-switch[role='switch']");
    switchEls.forEach((switchEl) => {
      switchEl.addEventListener('click', handleToggleClick, false);
      // Prevent focus on switch when clicking on it
      switchEl.addEventListener('mousedown', (event) => {
        event.preventDefault();
      });
    });

    // Prevent focus to switch on clicking label
    const labelEls = document.querySelectorAll('label.toggle-switch');
    labelEls.forEach((labelEl) => {
      labelEl.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent focus
        event.target.control.click(); // Activate switch
      });
    });

    // Cleanup event listeners on component unmount
    return () => {
      switchEls.forEach((switchEl) => {
        switchEl.removeEventListener('click', handleToggleClick, false);
        switchEl.removeEventListener('mousedown', (event) => {
          event.preventDefault();
        });
      });
      labelEls.forEach((labelEl) => {
        labelEl.removeEventListener('click', (event) => {
          event.preventDefault();
          event.target.control.click();
        });
      });
    };
  }, []);

  const handleSwitch = (e) => {
    const switchEl = e.target;
    const isChecked = switchEl.getAttribute('aria-checked') === 'true';
    if (isChecked) {
      console.log("Switch is ON");
      setToggle(true)
    } else {
      console.log("Switch is OFF");
      setToggle(false)
    }
  }

  return (
    <div>
      <div class="toggle-container">
        <button role="switch" aria-checked="false" id="biggerSwitch" class="toggle-switch tog-big"
        onClick={(e) => handleSwitch(e)} aria-readonly={isDisabled}>
          <span aria-hidden="true">✔</span>
          <span class="knob"></span>
          <span aria-hidden="true">✖</span>
        </button>
      </div>

    </div>
  );
};

export default ToggleSwitchComponent;
